import { memo } from "react";
import Hero from "../components/Solution/Hero";
import SolutionBreakdown from "../components/Solution/SolutionBreakdown";
import PVTExplanation from "../components/Solution/PVTExplanation";
import DataVisuals from "../components/Solution/DataVisuals";
import CaseStudies from "../components/Solution/CaseStudies";
import useDocumentTitle from "../hooks/useDocumentTitle";
import useImagePreloader from "../hooks/useImagePreloader";
import LoadingOverlay from "../components/LoadingOverlay";

import solutionHeroImage from "/images/Solution/Hero.webp";
import project1Image from "/images/Solution/Project1.webp";
import project2Image from "/images/Solution/Project2.webp";

const Solution = memo(function Solution() {
  useDocumentTitle("solution");

  const imagesToLoad = [solutionHeroImage, project1Image, project2Image];

  const loading = useImagePreloader(imagesToLoad);

  const caseImages = {
    project1: project1Image,
    project2: project2Image,
  };

  return (
    <>
      {loading && <LoadingOverlay />}
      <main>
        <Hero heroImage={solutionHeroImage} />
        <PVTExplanation />
        <SolutionBreakdown />
        <CaseStudies caseImages={caseImages} />
        <DataVisuals />
      </main>
    </>
  );
});

export default Solution;
